import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { of, map } from 'rxjs';
import { GeocodingService } from '../admin-dashboard/services';
import { EventsBrowseService } from './events-browse.service';

export const eventsMapResolver: ResolveFn<any> = (route) => {
  const geoCodingService = inject(GeocodingService);
  const eventsBrowseService = inject(EventsBrowseService);

  if (eventsBrowseService.eventsGeoJSON) {
    return of('ok');
  }

  return geoCodingService.getEventsGeoJSON().pipe(
    map( (res) => {
      if (!res.eventsGeoJSON || res.eventsGeoJSON.features?.length <=0) {
        eventsBrowseService.disableMap = true;
        return of();
      }
      eventsBrowseService.eventsGeoJSON = res;
      return of('ok');
    }),
  );
};
